import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import isSpa from "shared/util/isSpa";
import Link from "shared/components/Link";
import Str from "shared/components/Str";
import formattedLikesCount from "shared/util/formattedLikesCount";

import { selectedOptionOnNavBarEvent } from "routers/Desktop/NavBar/components/util/analytics";
import { ICON_SIZE } from "routers/Desktop/NavBar/components/util/constants";

import LikesIcon from "./icons/Likes.svg";

const LikesLink = ({ isSelected, likesCount }) => (
	<Link
		to="/who-likes-you"
		className={classnames("navbar-link", { isSelected })}
		id="nav_ratings"
		onClick={() => {
			selectedOptionOnNavBarEvent("Likes");
		}}
		noSpa={!isSpa()}
	>
		<div className="navbar-link-icon-container" >
			<LikesIcon
				className={classnames("navbar-link-icon", {
					isSelected,
				})}
				width={ICON_SIZE}
				height={ICON_SIZE}
			/>
			{/**
				The likesCount can be jQuery-ed in via InstantEvents
				need id="navbar-ratings", nav_ratings_badge
				& span, className="count".
			*/}
			<div id={likesCount !== null ? "" : "navbar-ratings"}>
				{
					likesCount
						? (
							<div className="navbar-likes-count">
								<span className="count">
									{formattedLikesCount(likesCount)}
								</span>
							</div>
						)
						: null
				}
			</div>
		</div>
		<span className="navbar-link-text">
			<Str>Likes</Str>
		</span>
	</Link>
);

LikesLink.propTypes = {
	isSelected: PropTypes.bool,
	likesCount: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
};

LikesLink.defaultProps = {
	isSelected: false,
	likesCount: null,
};

export default LikesLink;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/LikesLink.jsx